import Nav from "./components/Nav";
import Hero from "./components/Hero";
import Logos from "./components/Logos";
import Services from "./components/Services";
import Metrics from "./components/Metrics";
import Pricing from "./components/Pricing";
import CTA from "./components/CTA";
import Footer from "./components/Footer";

export default function App() {
  return (
    <div className="app-shell">
      <Nav />
      <main>
        <Hero />
        <Logos />
        <Services />
        <Metrics />
        <Pricing />
        <CTA />
      </main>
      <Footer />
    </div>
  );
}
